module.exports = __webpack_public_path__ + "static/media/emptySectionNew.ec9fb462.svg";